// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__8rED3","label":"SetPasswdForm_label__1_GZA"};